// extracted by mini-css-extract-plugin
export default {"content":"yE-z"};